{
  "DATE_PICKER": {
    "APPLY_BUTTON": "Appliquer",
    "CLEAR_BUTTON": "Clear",
    "DATE_RANGE_INPUT": {
      "START": "Start Date",
      "END": "End Date"
    },
    "DATE_RANGE_OPTIONS": {
      "TITLE": "DATE RANGE",
      "TODAY": "Aujourd'hui",
      "YESTERDAY": "Hier",
      "LAST_7_DAYS": "7 derniers jours",
      "LAST_30_DAYS": "30 derniers jours",
      "LAST_3_MONTHS": "3 derniers mois",
      "LAST_6_MONTHS": "6 derniers mois",
      "LAST_YEAR": "Année dernière",
      "CUSTOM_RANGE": "Plage de date personnalisée"
    }
  }
}
